import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
  },
  dialogTitle: {
    borderBottom: '1px solid #f0f0f0',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h5': {
      fontWeight: 600,
      fontSize: '20px',
      color: '#2c3e50'
    }
  },
  closeButton: {
    color: '#757575'
  },
  dialogContent: {
    padding: '24px 24px 16px'
  },
  note: {
    padding: '20px',
    borderRadius: '12px',
    backgroundColor: 'rgba(3, 169, 244, 0.08)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    marginBottom: '24px',
    border: '1px solid rgba(3, 169, 244, 0.2)'
  },
  noteHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '16px',
    userSelect: 'none'
  },
  accordionIcon: {
    color: '#455a64',
    fontSize: '20px'
  },
  noteHead: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#2c3e50',
    lineHeight: 1.5
  },
  noteSteps: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  stepItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px'
  },
  stepNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    backgroundColor: '#03a9f4',
    color: 'white',
    fontWeight: 600,
    fontSize: '14px',
    flexShrink: 0
  },
  stepText: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#37474f',
    lineHeight: 1.6,
    paddingTop: '4px'
  },
  fileFormatInfo: {
    marginLeft: '40px',
    marginTop: '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '12px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
  },
  formatTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 600,
    color: '#455a64'
  },
  formatHeaderCell: {
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid #6f6f6f'
  },
  required: {
    fontWeight: 'bold',
    fontSize: '18px',
    color: '#f44336'
  },
  roleInfoBox: {
    marginTop: '16px',
    backgroundColor: 'rgba(255, 193, 7, 0.1)',
    padding: '12px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    borderLeft: '4px solid #ffc107'
  },
  roleInfoIcon: {
    color: '#f57c00',
    marginTop: '3px',
    fontSize: '18px'
  },
  roleInfoText: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#5d4037',
    lineHeight: '1.5'
  },
  sampleDownloadButton: {
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    borderColor: '#03a9f4',
    color: '#0277bd',
    '&:hover': {
      backgroundColor: '#e3f2fd',
      borderColor: '#0277bd',
      boxShadow: '0 2px 5px rgba(3, 169, 244, 0.15)'
    }
  },
  sectionLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#455a64'
  },
  radioCard: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    border: `1px solid ${theme?.palette?.divider ?? '#e0e0e0'}`,
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'border-color 0.2s, background-color 0.2s',
    userSelect: 'none'
  },
  radioCardSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: 'rgba(3, 169, 244, 0.08)'
  },
  radioCardLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  input: {
    display: 'none'
  },
  upload: {
    textTransform: 'none',
    flex: 1,
    justifyContent: 'flex-start',
    padding: '14px 16px',
    fontSize: '14px',
    fontWeight: 500,
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    background: '#FFFFFF',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#03a9f4',
      boxShadow: '0 2px 5px rgba(3, 169, 244, 0.15)'
    }
  },
  helperText: {
    fontSize: '12px',
    color: theme.palette.text.secondary
  },
  error: {
    marginTop: '8px',
    marginLeft: '4px',
    color: '#f44336',
    fontWeight: 500,
    fontSize: '13px'
  },
  tableContainer: {
    marginTop: '24px',
    borderRadius: '8px',
    padding: '16px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0'
  },
  tableTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#2c3e50',
    marginBottom: '16px'
  },
  importInfo: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: '#f5f9ff',
    borderRadius: '8px',
    border: '1px solid rgba(3, 169, 244, 0.2)',
    margin: '0 0 16px'
  },
  infoNumberCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#03a9f4',
    color: 'white',
    fontWeight: 600,
    fontSize: '14px',
    marginRight: '12px',
    flexShrink: 0
  },
  importInfoText: {
    fontSize: '14px',
    color: '#455a64',
    fontWeight: 500
  },
  reviewTable: {
    marginBottom: '16px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    borderRadius: '8px',
    overflow: 'auto',
    border: '1px solid #e0e0e0',
    maxHeight: '300px',
    position: 'relative'
  },
  reviewHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: '#f5f9ff'
  },
  reviewHeaderCell: {
    backgroundColor: '#f5f9ff',
    color: '#0277bd',
    fontWeight: 600,
    padding: '10px 12px',
    fontSize: '13px',
    borderBottom: '1px solid #e0e0e0'
  },
  reviewCell: {
    padding: '10px 12px',
    fontSize: '13px',
    color: '#455a64',
    borderBottom: '1px solid #f0f0f0'
  },
  cellError: {
    backgroundColor: 'rgba(244, 67, 54, 0.08)',
    color: '#c62828',
    fontWeight: 600
  },
  cellConflict: {
    backgroundColor: 'rgba(255, 152, 0, 0.12)',
    color: '#e65100',
    fontWeight: 600
  },
  missingValue: {
    color: '#f44336',
    fontStyle: 'italic',
    fontWeight: 600,
    fontSize: '12px'
  },
  requiredMark: {
    color: '#f44336',
    fontWeight: 'bold',
    fontSize: '16px',
    marginLeft: '2px'
  },
  warningBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '12px 16px',
    backgroundColor: 'rgba(244, 67, 54, 0.07)',
    border: '1px solid rgba(244, 67, 54, 0.3)',
    borderRadius: '8px',
    margin: '0 0 16px'
  },
  warningIcon: {
    color: '#f44336',
    fontSize: '20px',
    flexShrink: 0,
    marginTop: '1px'
  },
  warningText: {
    fontSize: '13px',
    color: '#b71c1c',
    lineHeight: 1.6
  },
  // Counter conflict banner styles
  conflictBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '14px 16px',
    backgroundColor: 'rgba(255, 152, 0, 0.08)',
    border: '1px solid rgba(255, 152, 0, 0.4)',
    borderRadius: '8px',
    margin: '0 0 16px'
  },
  conflictIcon: {
    color: '#e65100',
    fontSize: '22px',
    flexShrink: 0,
    marginTop: '2px'
  },
  conflictText: {
    fontSize: '13px',
    color: '#4e2600',
    lineHeight: 1.6,
    marginBottom: '6px'
  },
  conflictQuestion: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#4e2600',
    marginBottom: '4px'
  },
  conflictHint: {
    fontSize: '12px',
    color: '#6d4c41',
    lineHeight: 1.5,
    marginTop: '2px'
  },
  conflictYesBtn: {
    backgroundColor: '#ff9800',
    color: '#fff',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#e65100'
    }
  },
  conflictNoBtn: {
    borderColor: '#ff9800',
    color: '#e65100',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'rgba(255, 152, 0, 0.08)'
    }
  },
  conflictDecisionNote: {
    fontSize: '13px',
    color: '#4e2600',
    fontWeight: 500,
    marginTop: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  changeDecisionBtn: {
    textTransform: 'none',
    fontSize: '12px',
    color: '#0277bd',
    padding: '0 4px',
    minWidth: 'unset'
  },
  buttonBox: {
    borderTop: '1px solid #efefef',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 24px'
  }
}))
